<template>
    <b-col sm="12">
      <b-form-group v-if="showB2C">
        <b-form-radio-group
            id="radio-group-2"
            name="radio-sub-component"
            v-model="B2C"
        >
          <b-form-radio value="Buiness" style="vertical-align: baseline">Business</b-form-radio>
          <b-form-radio value="Private" style="vertical-align: baseline" >Private</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Addressbook')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <vSelectMulti
                        :dynamicWidth="true"
                        label="label"
                        :options="limitedAddressBook"
                        :placeholder="$t('createShipment.placeholder.Search Addressbook')"
                        :key="refPrefix + 'AddressBook'"
                        @input="setData"
                        :disabled="!canEdit"
                        :name="refPrefix + 'AddressBook'"
                        :ref="refPrefix + 'AddressBook'"
                        v-model="selectedAddress"
                        :filter="filter"
                        :getOptionLabel="(option) => option.label"
                    />
                </b-col>
            </b-input-group>
        </b-form-group>
      <b-form-group
          label-cols-sm="3"
          :label="$t('createShipment.label.AccountNumber')"
          label-align-sm="left"
          v-if="showAccountNumber"
      >
        <b-input-group size="sm">
          <b-col sm="11">
            <b-form-input
                size="sm"
                type="text"
                :name="'shipment.' + refPrefix + '.accountNumber'"
                v-model="address.accountNumber"
                aria-describedby="account-feedback"
                :class="{
                            'is-invalid': v.accountNumber.$error
                        }"
                @update="v.accountNumber.$touch()"
                :disabled="!canEdit"
            />
            <b-form-invalid-feedback
                id="phone-feedback"
                :name="'shipment.' + refPrefix + '.accountNumber.error'"
                v-if="v.accountNumber.$error"
            >
            </b-form-invalid-feedback>
          </b-col>
        </b-input-group>
      </b-form-group>
      <b-form-group
          label-cols-sm="3"
          :label="$t('createShipment.label.VatNumber')"
          label-align-sm="left"
          v-if="showVatNumber"
      >
        <b-input-group size="sm">
          <b-col sm="11">
            <b-form-input
                size="sm"
                type="text"
                :name="'shipment.' + refPrefix + '.vatNumber'"
                v-model="address.vatNumber"
                aria-describedby="account-feedback"
                :class="{
                            'is-invalid': v.vatNumber.$error
                        }"
                @update="v.vatNumber.$touch()"
                :disabled="!canEdit"
            />
            <b-form-invalid-feedback
                id="phone-feedback"
                :name="'shipment.' + refPrefix + '.vatNumber.error'"
                v-if="v.vatNumber.$error"
            >
            </b-form-invalid-feedback>
          </b-col>
        </b-input-group>
      </b-form-group>
      <b-form-group
          label-cols-sm="3"
          :label="$t('createShipment.label.EoriNumber')"
          label-align-sm="left"
          v-if="showEoriNumber && address.countryCode === 'GB'"
      >
        <b-input-group size="sm">
          <b-col sm="11">
            <b-form-input
                size="sm"
                type="text"
                :name="'shipment.' + refPrefix + '.EoriNumber'"
                v-model="address.eoriNumber"
                aria-describedby="account-feedback"
                :disabled="!canEdit"
            />
          </b-col>
        </b-input-group>
      </b-form-group>
      <b-form-group
          label-cols-sm="3"
          :label="$t('createShipment.label.DutyAccountNumber')"
          label-align-sm="left"
          v-if="showDutyAccountNumber"
      >
        <b-input-group size="sm">
          <b-col sm="11">
            <b-form-input
                size="sm"
                type="text"
                :name="'shipment.' + refPrefix + '.DutyAccountNumber'"
                v-model="address.dutyAccountNumber"
                aria-describedby="account-feedback"
                :disabled="!canEdit"
            />
          </b-col>
        </b-input-group>
      </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.CompanyName')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        size="sm"
                        type="text"
                        v-model="address.name"
                        :name="'shipment.' + refPrefix + '.name'"
                        max="31"
                        aria-describedby="name-feedback"
                        :class="{ 'is-invalid': v.name.$error }"
                        @update="v.name.$touch()"
                        :disabled="(address.isPrivate && showB2C) || !canEdit"                    
                    />

                    <b-form-invalid-feedback
                        id="name-feedback"
                        :name="'shipment.' + refPrefix + '.name.error'"
                        v-if="v.name.$error"
                    >
                        <validationRequired
                            fieldName="createShipment.label.CompanyName"
                            :fieldValid="v.name.required"
                        />

                        <validationMaxLength
                            fieldName="createShipment.label.CompanyName"
                            :fieldValid="v.name.maxLength"
                            :fieldMax="v.name.$params.maxLength.max"
                        />
                    </b-form-invalid-feedback>
                </b-col>
                <b-input-group-append v-if="!address.isPrivate">
                    <div>
                      <requiredIcon
                          :active="(showB2C && (hasShipmentOptions || isEditAddress))"
                          :name="'shipment.' + refPrefix + '.nameRequiredIcon'"
                      />
                    </div>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Street 1')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        size="sm"
                        type="text"
                        v-model="address.street1"
                        :name="'shipment.' + refPrefix + '.street1'"
                        max="51"
                        aria-describedby="street1-feedback"
                        :class="{ 'is-invalid': v.street1.$error }"
                        @update="v.street1.$touch()"
                        :disabled="!canEdit"
                    />

                    <b-form-invalid-feedback
                        id="street1-feedback"
                        :name="'shipment.' + refPrefix + '.street1.error'"
                        v-if="v.street1.$error"
                    >
                        <validationRequired
                            fieldName="createShipment.label.Street 1"
                            :fieldValid="v.street1.required"
                        />

                        <validationMaxLength
                            fieldName="createShipment.label.Street 1"
                            :fieldValid="v.street1.maxLength"
                            :fieldMax="v.street1.$params.maxLength.max"
                        />
                    </b-form-invalid-feedback>
                </b-col>
                <b-input-group-append>
                    <div>
                        <requiredIcon
                            :active="hasShipmentOptions || isEditAddress"
                            :name="'shipment.' + refPrefix + '.street1RequiredIcon'"
                        />
                    </div>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Street 2')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        size="sm"
                        type="text"
                        v-model="address.street2"
                        :name="'shipment.' + refPrefix + '.street2'"
                        aria-describedby="street2-feedback"
                        :class="{ 'is-invalid': v.street2.$error }"
                        @update="v.street2.$touch()"
                        :disabled="!canEdit"
                    />
                    <b-form-invalid-feedback
                        id="street2-feedback"
                        :name="'shipment.' + refPrefix + '.street2.error'"
                        v-if="v.street2.$error"
                    >
                        <validationMaxLength
                            fieldName="createShipment.label.Street 2"
                            :fieldValid="v.street2.maxLength"
                            :fieldMax="v.street2.$params.maxLength.max"
                        />
                    </b-form-invalid-feedback>
                </b-col>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Street 3')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        size="sm"
                        type="text"
                        v-model="address.street3"
                        :name="'shipment.' + refPrefix + '.street3'"
                        aria-describedby="street3-feedback"
                        :class="{ 'is-invalid': v.street3.$error }"
                        @update="v.street3.$touch()"
                        :disabled="!canEdit"
                    />
                    <b-form-invalid-feedback
                        id="street3-feedback"
                        :name="'shipment.' + refPrefix + '.street3.error'"
                        v-if="v.street3.$error"
                    >
                        <validationMaxLength
                            fieldName="createShipment.label.Street 3"
                            :fieldValid="v.street3.maxLength"
                            :fieldMax="v.street3.$params.maxLength.max"
                        />
                    </b-form-invalid-feedback>
                </b-col>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Postalcode')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        v-model="address.postalCode"
                        size="sm"
                        type="text"
                        :name="'shipment.' + refPrefix + '.postalCode'"
                        aria-describedby="postalCode-feedback"
                        :class="{ 'is-invalid': v.postalCode.$error }"
                        @update="v.postalCode.$touch()"
                        :disabled="!canEdit"
                    />

                    <b-form-invalid-feedback
                        id="postalCode-feedback"
                        :name="'shipment.' + refPrefix + '.postalCode.error'"
                        v-if="v.postalCode.$error"
                    >
                        <validationMaxLength
                            fieldName="createShipment.label.Postalcode"
                            :fieldValid="v.postalCode.maxLength"
                            :fieldMax="v.postalCode.$params.maxLength.max"
                        />
                    </b-form-invalid-feedback>
                </b-col>
              <b-input-group-append v-if="isEditAddress">
                    <span
                        @click="displayPostalCodeModal"
                        style="cursor: pointer; display: flex; align-items: center; border: 1px solid #ced4da; border-left: 0; padding: 0 8px; background-color: #e9ecef;"
                    >
                        <font-awesome-icon icon="search" />
                    </span>
              </b-input-group-append>
                <b-input-group-append v-if="!isEditAddress">
                    <font-awesome-icon
                        icon="search"
                        @click="displayPostalCodeModal"
                        name="postalCodeIcon"
                    ></font-awesome-icon>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.City')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        v-model="address.city"
                        size="sm"
                        type="text"
                        :name="'shipment.' + refPrefix + '.city'"
                        aria-describedby="city-feedback"
                        :class="{ 'is-invalid': v.city.$error }"
                        @update="v.city.$touch()"
                        :disabled="!canEdit"
                    />

                    <b-form-invalid-feedback
                        id="city-feedback"
                        :name="'shipment.' + refPrefix + '.city.error'"
                        v-if="v.city.$error"
                    >
                        <validationRequired
                            fieldName="createShipment.label.City"
                            :fieldValid="v.city.required"
                        />
                        <validationMaxLength
                            fieldName="createShipment.label.City"
                            :fieldValid="v.city.maxLength"
                            :fieldMax="v.city.$params.maxLength.max"
                        />
                    </b-form-invalid-feedback>
                </b-col>
                <b-input-group-append>
                    <div>
                        <requiredIcon />
                    </div>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Country')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <vSelect
                        :dynamicWidth="true"
                        :options="listOfCountries"
                        :placeholder="$t('createShipment.placeholder.Choose Country')"
                        :reduce="(country) => country.countryCode"
                        label="countryName"
                        v-model="address.countryCode"
                        :name="'shipment.' + refPrefix + '.countryCode'"
                        aria-describedby="country-feedback"
                        :class="{ 'is-invalid': v.countryCode.$error }"
                        @input="countryChanged"
                        :select-on-tab="true"
                        :disabled="!canEdit || lockCountry"
                    />
                    <b-form-invalid-feedback
                        id="country-feedback"
                        :name="'shipment.' + refPrefix + '.countryCode.error'"
                        :state="!v.countryCode.$error"
                        v-if="v.countryCode.$dirty"
                    >
                        <validationRequired
                            fieldName="createShipment.label.Country"
                            :fieldValid="v.countryCode.required"
                        />
                    </b-form-invalid-feedback>
                </b-col>
                <b-input-group-append>
                    <div>
                        <requiredIcon />
                    </div>
                </b-input-group-append>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.State')"
            label-align-sm="left"
            v-if="listOfStates.some((x) => x.countryCode === address.countryCode)"
            key="state"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <vSelect
                        :dynamicWidth="true"
                        :options="listOfStates"
                        :reduce="(s) => s.stateCode"
                        label="stateName"
                        v-model="address.stateCode"
                        placeholder="Choose State"
                        :name="'shipment.' + refPrefix + '.stateCode'"
                        :disabled="!canEdit"
                        aria-describedby="stateCode-feedback"
                        :class="{ 'is-invalid': v.stateCode.$error }"
                        @input="v.stateCode.$touch()"
                        :select-on-tab="true"
                    />
                </b-col>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Contact Person')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        size="sm"
                        type="text"
                        :name="'shipment.' + refPrefix + '.contactPerson.name'"
                        v-model="address.contactPerson.name"
                        aria-describedby="contactPerson-feedback"
                        :class="{
                            'is-invalid': v.contactPerson.name.$error
                        }"
                        @update="v.contactPerson.name.$touch()"
                        :disabled="!canEdit"
                    />
                    <b-form-invalid-feedback
                        id="contactPerson-feedback"
                        :name="'shipment.' + refPrefix + '.contactPerson.name.error'"
                        v-if="v.contactPerson.name.$error"
                    >
                        <validationMaxLength
                            fieldName="createShipment.label.Contact Person"
                            :fieldValid="v.contactPerson.name.maxLength"
                            :fieldMax="v.contactPerson.name.$params.maxLength.max"
                        />
                      <validationRequired
                          fieldName="createShipment.label.Contact Person"
                          :fieldValid="v.contactPerson.name.required"
                      />
                    </b-form-invalid-feedback>
                </b-col>
              <div>
                <requiredIcon
                    v-if="noContactPerson"
                    :active="hasShipmentOptions || isEditAddress"
                    :name="'shipment.' + refPrefix + '.nameRequiredIcon'"
                />
              </div>
            </b-input-group>
        </b-form-group>
        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Phone')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        size="sm"
                        type="text"
                        :name="'shipment.' + refPrefix + '.contactPerson.phone'"
                        v-model="address.contactPerson.phone"
                        aria-describedby="phone-feedback"
                        :class="{
                            'is-invalid': v.contactPerson.phone.$error
                        }"
                        @update="v.contactPerson.phone.$touch()"
                        :disabled="!canEdit"
                    />
                    <b-form-invalid-feedback
                        id="phone-feedback"
                        :name="'shipment.' + refPrefix + '.contactPerson.phone.error'"
                        v-if="v.contactPerson.phone.$error"
                    >
                        <validationMaxLength
                            fieldName="createShipment.label.Phone"
                            :fieldValid="v.contactPerson.phone.maxLength"
                            :fieldMax="v.contactPerson.phone.$params.maxLength.max"
                        />
                      <validationRequired
                          fieldName="createShipment.label.Phone"
                          :fieldValid="v.contactPerson.phone.required"
                      />
                    </b-form-invalid-feedback>
                </b-col>
              <div>
                <requiredIcon
                    v-if="noPhoneNo"
                    :active="hasShipmentOptions || isEditAddress"
                    :name="'shipment.' + refPrefix + '.nameRequiredIcon'"
                />
              </div>
            </b-input-group>
        </b-form-group>

        <div
            v-for="(item, index) in address.contactPerson.mails"
            v-bind:key="item.key"
        >
            <b-form-group
                label-cols-sm="3"
                :label="$t('createShipment.label.Email')"
                label-align-sm="left"
            >
                <b-input-group size="sm">
                    <b-col :sm="noEmail ? 10 : 11">
                        <b-form-input
                            size="sm"
                            type="email"
                            v-model="address.contactPerson.mails[index]"
                            :name="'shipment.' + refPrefix + '.contactPerson.mails[' + index + ']'"
                            aria-describedby="mail-feedback"
                            :class="{
                                'is-invalid': v.contactPerson.mails.$each[index].$error
                            }"
                            @update="v.contactPerson.mails.$each[index].$touch()"
                            :disabled="!canEdit"
                        />


                        <b-form-invalid-feedback
                            id="mail-feedback"
                            :name="
                                'shipment.' +
                                    refPrefix +
                                    '.contactPerson.mails[' +
                                    index +
                                    '].error'
                            "
                            v-if="v.contactPerson.mails.$each[index].$error"
                        >
                            <validationMaxLength
                                fieldName="createShipment.label.Email"
                                :fieldValid="v.contactPerson.mails.$each[index].maxLength"
                                :fieldMax="v.contactPerson.mails.$each[index].$params.maxLength.max"
                            />
                          <validationRequired
                              fieldName="createShipment.label.Email"
                              :fieldValid="v.contactPerson.mails.required"
                          />
                        </b-form-invalid-feedback>
                    </b-col>
                  <b-input-group-append v-if="index === 0">
      
                    <requiredIcon
                        v-if="noEmail"
                        :active="hasShipmentOptions || isEditAddress"
                        :name="'shipment.' + refPrefix + '.nameRequiredIcon'"
                        style="position: relative; right: calc(100% + -41px);"
                    />
                  </b-input-group-append>
                    <b-input-group-append v-if="index > 0">
                        <font-awesome-icon
                            @click="removeEmail"
                            icon="minus-circle"
                            size="lg"
                            color="#dc3545"
                        />
                      <requiredIcon
                          v-if="noEmail"
                          :active="hasShipmentOptions || isEditAddress"
                          :name="'shipment.' + refPrefix + '.nameRequiredIcon'"
                          style="position: relative; right: calc(100% + -41px);"
                      />
                    </b-input-group-append>
                    <b-input-group-append
                        v-if="index === 0 && address.contactPerson.mails.length < 10"
                    >
                      
                        <font-awesome-icon
                            v-if="noEmail"
                            @click="addEmail"
                            icon="plus-circle"
                            size="lg"
                            color="#AFCC8B"
                            class="addEmailIcon"
                            :name="refPrefix + 'AddMailButton'"
                            style="position: relative; right: calc(100% + 0px);"
                        />
                      <font-awesome-icon
                          v-if="!noEmail"
                          @click="addEmail"
                          icon="plus-circle"
                          size="lg"
                          color="#AFCC8B"
                          class="addEmailIcon"
                          :name="refPrefix + 'AddMailButton'"
                          style="position: relative; right: calc(100% + -12px);"
                      />
           
                    </b-input-group-append>
    
                </b-input-group>
            </b-form-group>
        </div>

        <b-form-group
            v-if="isEditAddress"
            label-cols-sm="3"
            :label="$t('createShipment.label.SearchText')"
            label-align-sm="left"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-input
                        size="sm"
                        type="text"
                        v-model="address.searchText"
                    />
                </b-col>
            </b-input-group>
        </b-form-group>
      
        <b-form-group
          v-if="isEditAddress"
          label-cols-sm="3"
          :label="$t('createShipment.label.Notice')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="11">
            <b-form-input
                size="sm"
                type="text"
                v-model="address.comment"
            />
          </b-col>
        </b-input-group>
      </b-form-group>
      
        <b-form-group
          v-if = "!isEditAddress && address.comment"  
          label-cols-sm="3"
          :label="$t('createShipment.label.Notice')"
          label-align-sm="left"
      >
        <b-input-group size="sm">
          <b-col sm="11">
            <label style="color: orangered">{{address.comment}}</label>
          </b-col>
        </b-input-group>
      </b-form-group>

        <b-form-group
            label-cols-sm="3"
            :label="$t('createShipment.label.Save Address')"
            label-align-sm="left"
            v-if="!isEditAddress"
        >
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-form-checkbox
                        class="float-left"
                        size="sm"
                        :name="refPrefix + 'SaveAddressCheckbox'"
                        v-model="saveAddress"
                    ></b-form-checkbox>
                </b-col>
            </b-input-group>
        </b-form-group>

        <b-form-group label-cols-sm="3" v-if="!isEditAddress">
            <b-input-group size="sm">
                <b-col sm="11">
                    <b-button
                        @click="clearAddress"
                        :name="refPrefix + 'ClearButton'"
                        variant="outline-secondary"
                        size="sm"
                        style="float: left;"
                    >{{ $t('createShipment.label.ClearButton') }}</b-button>

                    <b-button
                        v-if="!isEditAddress && selectedAddress"
                        @click="displayEditAddressModal"
                        :name="refPrefix + 'EditAddressButton'"
                        variant="outline-secondary"
                        size="sm"
                        style="float: left; margin-left: 10px"
                    >{{ $t('createShipment.label.EditAddressButton') }}</b-button>
                </b-col>
            </b-input-group>
        </b-form-group>
        <postalCode
            :refPrefix="refPrefix"
            @inputPostalCode="setPostalCode"
            :selectable="true"
            :countryCode="address.countryCode"
        />

        <editAddress
            v-if="!isEditAddress"
            :addressToEdit="addressCopy"
            :refPrefix="'editModal' + refPrefix"
            @updateAddress="updateAddress"
            @deleteAddress="deleteAddress"
            @createAddress="createAddress"
        />
    </b-col>
</template>
<script>
  import vSelectMulti from './vSelectMultiLine';
  import vSelect from './vSelect';
  import postalCode from './postal-code';
  import editAddress from './editAddress';
  import { required, maxLength } from 'vuelidate/lib/validators';
  import { isUndefined } from 'util';
  import { ACTIONS, CREATE_SHIPMENT_PREFIX } from '../store/constants';
  import validationRequired from './Validation/ValidationRequired';
  import validationMaxLength from './Validation/ValidationMaxLength';
  import { mapGetters } from 'vuex';
  import resetMixin from '../mixins/resetMixin';
  import requiredIcon from './requiredIcon';
  import helpers from '../helper';
  export default {
      props: {
          cardHeaderText: String,
          collapsed: { type: Boolean, default: true },
          saveFlags: { type: Object },
          address: {
              required: true,
          },
          refPrefix: {
              required: true,
          },
          v: { required: true },
          canEdit: { type: Boolean, default: true },
          lockCountry: { type: Boolean, default: false },
          isEditAddress: { type: Boolean, default: false },
          showAccountNumber: {type: Boolean, default:false},
          showVatNumber: {type: Boolean, default:false},
          showEoriNumber: {type: Boolean, default:false},
          showDutyAccountNumber: {type: Boolean, default:false},
          addressBookType: {type: String, default: "AddressBook"},
          showB2C: {type: Boolean, default: false},
         
      },
      mixins: [resetMixin],
      components: {
          postalCode,
          editAddress,
          vSelect,
          vSelectMulti,
          validationRequired,
          validationMaxLength,
          requiredIcon,
      },
      watch: {
          'address.postalCode': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
          'address.city': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
          'address.countryCode': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
          'address.stateCode': {
              handler() {
                  this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
                  );
              },
          },
        'address.isPrivate': {
          handler(newValue) {
            this.$store.dispatch(
                CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CLEAR_SHOW_SHIPPING_OPTIONS
            );
            if (newValue) {
              this.address.name = "";
            }
          },
        },

          reset() {
              this.selectedAddress = null;
          },
      },
      data() {
          return {
              selectedAddress: null,
              B2COrB2B: {type: String, default:"Buiness"},
          };
      },
      computed: {
          ...mapGetters('createShipment', ['getAddressBook']),
        
        noEmail: function() {
          return this.getReqParameter('NoEmail')
        },

        noPhoneNo: function() {
          return this.getReqParameter('NoPhoneNo')
        },
        
        noContactPerson: function() {
            return this.getReqParameter('NoContactPerson')
        },
        
        addressCopy() {
              let copy = helpers.cloneObject(this.address);
              return copy;
          },
          saveAddress: {
              get() {
                  if (this.saveFlags != undefined) {
                      if (this.refPrefix === 'receiverAddress') {
                          return this.saveFlags.saveReceiverAddress;
                      }
                      if (this.refPrefix === 'senderAddress') {
                          return this.saveFlags.saveSenderAddress;
                      }
                      if (this.refPrefix === 'pickupAddress') {
                          return this.saveFlags.savePickupAddress;
                      }
                    if (this.refPrefix === 'soldToAddress') {
                      return this.saveFlags.saveSoldToAddress;
                    }
                    if (this.refPrefix === 'brokerAddress') {
                      return this.saveFlags.saveBrokerAddress;
                    }
                      
                  }
              },

              set(newValue) {
                  this.setSaveAddress(newValue);
              },
          },
          B2C: {
            get() {
              if (this.address.isPrivate)
                return "Private"
              return "Buiness"
            },
            set(newValue) {
                this.B2COrB2B = newValue
                if (newValue === "Private") {
                  this.address.isPrivate = true;
                }
                else
                  this.address.isPrivate = false;
            }
          },
          limitedAddressBook(){
            return this.addressBook.slice(0,500)
          },
          addressBook() {
              let result = this.getAddressBook;
              if (this.lockCountry) {
                  const country = this.getShipmentSystemCountryCode();
                  const filtered = result.filter((ab) => ab.countryCode === country);
                  result = filtered;
              }
              if (this.addressBookType === "AddressBook"){
                result = result.filter(a => (a.addressType === this.addressBookType || a.addressBookType == null) );
              } else if (this.addressBookType === "SoldTo"){
                result = result.filter(a => (a.addressType === this.addressBookType));
              } else {
                result = result.filter(a => a.addressType === this.addressBookType);  
              }
              return result;
          },
          listOfCountries() {
              return this.$store.state.core.countries;
          },
          listOfStates() {
              return this.$store.state.core.stateCodes.filter(
                  (x) => x.countryCode === this.address.countryCode
              );
          },
          ...mapGetters('createShipment', ['hasShipmentOptions']),
      },
      methods: {
          ...mapGetters('core', ['getShipmentSystemCountryCode']),

          setSaveAddress(newValue) {
              if (this.refPrefix === 'receiverAddress') {
                  this.saveFlags.saveReceiverAddress = newValue;
              }
              if (this.refPrefix === 'senderAddress') {
                  this.saveFlags.saveSenderAddress = newValue;
              }
              if (this.refPrefix === 'pickupAddress') {
                  this.saveFlags.savePickupAddress = newValue;
              }
              if (this.refPrefix === 'soldToAddress') {
                this.saveFlags.saveSoldToAddress = newValue;
              }
              if (this.refPrefix === 'brokerAddress') {
                this.saveFlags.saveBrokerAddress = newValue;
              }
          },

          filter(options, search) {
              let searchTextResult = this.addressBook.filter((option) => {
                  if (option.searchText === null) {
                      return;
                  }
                  return option.searchText.toLowerCase().includes(search.toLowerCase());
              });

              let label1SearchResult = this.addressBook.filter((option) => {
                  if (option.label1 === null) {
                      return;
                  }
                  return option.label1.toLowerCase().includes(search.toLowerCase());
              });

              let label2SearchResult = this.addressBook.filter((option) => {
                if (option.label2 === null) {
                  return;
                }
                return option.label2.toLowerCase().includes(search.toLowerCase());
              });

              let phoneSearchResult = this.addressBook.filter((option) => {
                  if (option.contactPerson === null) {
                      return;
                  }

                  if (option.contactPerson.phone === null) {
                      return;
                  }

                  return option.contactPerson.phone.toLowerCase().includes(search.toLowerCase());
              });

              let result = Array.from(
                  new Set(searchTextResult.concat(label1SearchResult).concat(phoneSearchResult).concat(label2SearchResult))
              );

              return result.slice(0,500);
          },

          updateAddress(addressToUpdate) {
              this.$store.dispatch(
                  CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.UPDATE_ADDRESS,
                  addressToUpdate
              );

              this.setData(addressToUpdate);
          },
          createAddress(addressToUpdate) {
            this.$store.dispatch(
                      CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.CREATE_ADDRESS,
                addressToUpdate
          );

          this.setData(addressToUpdate);
        },

          deleteAddress(addressId) {
              this.$store.dispatch(
                  CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.DELETE_ADDRESS,
                  addressId
              );

              const index = this.addressBook.findIndex((x) => x.addressId === addressId);

              if (index != -1) {
                  this.addressBook.splice(index, 1);
              }

              this.clearAddress();
          },

          setPostalCode(result) {
              this.address.postalCode = result.postalCode;
              this.address.city = result.city;
              this.address.countryCode = result.countryCode;
              this.address.stateCode = null;
          },
          countryChanged(data) {
              this.v.countryCode.$touch();
              this.address.stateCode = null;
          },
          displayPostalCodeModal() {
              const ref = this.refPrefix + '_postal-code-modal';
              this.$bvModal.show(ref);
          },

          displayEditAddressModal() {
              const ref = 'editModal' + this.refPrefix + '_edit-address-modal';
              this.$bvModal.show(ref);
          },

          setData(data) {
              if (!data) return;
              let clone = helpers.cloneObject(data);
              

              this.address.addressId = clone.addressId;
              this.address.name = clone.name;
              this.address.street1 = clone.street1;
              this.address.street2 = clone.street2;
              this.address.street3 = clone.street3;
              this.address.postalCode = clone.postalCode;
              this.address.city = clone.city;
              this.address.countryCode = clone.countryCode;
              this.address.contactPerson.name = clone.contactPerson.name;
              this.address.contactPerson.phone = clone.contactPerson.phone;
              this.address.contactPerson.mails = clone.contactPerson.mails;
              this.address.searchText = clone.searchText;
              this.address.comment = clone.comment;
              if (clone.addressType === "SoldTo") {
                this.address.accountNumber = clone.accountNumber
                this.address.vatNumber = clone.vatNumber
                this.address.eoriNumber = clone.eoriNumber
                this.address.dutyAccountNumber = clone.dutyAccountNumber
              }
              if (clone.stateCode != null && (clone.countryCode === 'US' || clone.countryCode === 'CA') ) {
                  this.address.stateCode = clone.stateCode;
              } else {
                  this.address.stateCode = null;
              }

              this.setSaveAddress(false);
          },
          isUndefined(value) {
              const r = void 0;
              return value === r;
          },
          addEmail() {
              if (this.address.contactPerson.mails.length < 10) {
                  this.address.contactPerson.mails.push('');

                  this.$nextTick().then(() => {
                      this.$forceUpdate();
                  });
              }
          },
          removeEmail() {
              if (this.address.contactPerson.mails.length > 1) {
                  this.address.contactPerson.mails.pop();
                  this.$nextTick().then(() => {
                      this.$forceUpdate();
                  });
              }
          },

          clearAddress() {
              this.address.name = null;
              this.address.street1 = null;
              this.address.street2 = null;
              this.address.street3 = null;
              this.address.postalCode = null;
              this.address.city = null;
              if (this.lockCountry !== true) {
                  this.address.countryCode = null;
              }
              this.address.contactPerson.name = null;
              this.address.contactPerson.phone = null;
              this.address.contactPerson.mails = [''];
              this.address.countryCode = null;
              this.address.stateCode = null;

              this.selectedAddress = null;
          },
        
        getReqParameter(optionName){
          let viewOptions = this.$store.getters[CREATE_SHIPMENT_PREFIX + ACTIONS.CREATESHIPMENT.GET_VIEW_OPTIONS]

          if (viewOptions !== undefined){
            const viewElement = viewOptions.filter((opt) => {
              return opt.name === optionName;
            })[0];
            if(viewElement === undefined){
              return false
            }
            return viewElement.required
          }
          return false;
        },
      },
  };
</script>

<style>
input[type="radio"] {
  vertical-align: baseline;
}
</style>
